export default __webpack_public_path__ + "static/screen_1_03-80f00b725675dfa9cbf711b4c88f4d1a.svg";